export default class UserAddController {
    constructor($routeParams, $location, $window, userService) {
        this.$location = $location;
        this.userService = userService;
        this.$window = $window;
        this.clientId = $routeParams.clientId;
        if(this.clientId != null)
            this.user = {
                clientId: this.clientId,
                userType: 4
            };
        else
            this.user = {
                userType: 3
            };
    }

    onSave() { 
        this.userService.add(this.user).then(resp => {
            if(this.clientId != null)
                this.$location.path(`/manage/clients/edit/${this.clientId}`);
            else //redirect to trainer
                this.$location.path(`/manage`);
        });
    }

    goBack(){
        this.$window.history.back();
    }
}


// WEBPACK FOOTER //
// ./src/js/components/users/users.add.controller.js